import * as React from "react";
const IconSchoolCollege = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.98633 7.99243C2.98633 9.33421 11.0925 12.9924 12.9863 12.9924C14.8802 12.9924 22.9863 9.33421 22.9863 7.99243C22.9863 6.65065 14.8802 2.99243 12.9863 2.99243C11.0925 2.99243 2.98633 6.65065 2.98633 7.99243Z"
      stroke="#1C1C2C"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.98633 10.9924L7.23178 16.6223C7.23669 16.7351 7.24889 16.8479 7.28161 16.9559C7.38272 17.2898 7.56907 17.5931 7.85339 17.7968C10.0779 19.391 15.8947 19.391 18.1193 17.7968C18.4036 17.5931 18.5899 17.2898 18.6911 16.9559C18.7238 16.8479 18.736 16.7351 18.7409 16.6223L18.9863 10.9924"
      stroke="#1C1C2C"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.2363 9.49243C22.2363 9.07822 21.9005 8.74243 21.4863 8.74243C21.0721 8.74243 20.7363 9.07822 20.7363 9.49243H22.2363ZM20.0578 19.7559L20.7874 19.9292L20.0578 19.7559ZM22.9149 19.7559L23.6446 19.5825L22.9149 19.7559ZM20.7363 9.49243V16.4996H22.2363V9.49243H20.7363ZM20.7874 19.9292C20.9323 19.3194 21.1815 18.7621 21.4482 18.2403C21.6925 17.7621 22.0126 17.2089 22.1839 16.7751L20.7888 16.2241C20.6518 16.5708 20.4228 16.9505 20.1125 17.5577C19.8245 18.1213 19.5135 18.8019 19.3281 19.5825L20.7874 19.9292ZM23.6446 19.5825C23.4592 18.8019 23.1482 18.1213 22.8602 17.5577C22.5499 16.9505 22.3208 16.5708 22.1839 16.2241L20.7888 16.7751C20.9601 17.2089 21.2801 17.7621 21.5245 18.2403C21.7912 18.7621 22.0403 19.3194 22.1852 19.9292L23.6446 19.5825ZM21.8018 20.2424H21.1709V21.7424H21.8018V20.2424ZM19.3281 19.5825C19.2047 20.1019 19.1306 20.7888 19.6198 21.2795C19.8489 21.5093 20.1314 21.6172 20.3802 21.6723C20.6282 21.7273 20.9003 21.7424 21.1709 21.7424V20.2424C20.9426 20.2424 20.7964 20.2282 20.705 20.2079C20.6143 20.1878 20.6363 20.1745 20.682 20.2204C20.7397 20.2782 20.7405 20.3322 20.7377 20.3019C20.7333 20.255 20.7367 20.1429 20.7874 19.9292L19.3281 19.5825ZM22.1852 19.9292C22.236 20.1429 22.2394 20.255 22.235 20.3019C22.2321 20.3322 22.2329 20.2782 22.2906 20.2204C22.3364 20.1745 22.3583 20.1878 22.2677 20.2079C22.1762 20.2282 22.03 20.2424 21.8018 20.2424V21.7424C22.0723 21.7424 22.3445 21.7273 22.5924 21.6723C22.8412 21.6172 23.1237 21.5093 23.3529 21.2795C23.842 20.7888 23.768 20.1019 23.6446 19.5825L22.1852 19.9292Z"
      fill="#1C1C2C"
    />
  </svg>
);
export default IconSchoolCollege;
